<template>
  <Organisation title="Account | Organisation Settings">
    <div class="container">
      <div class="row">
        <div class="col-sm-8 offset-sm-2">
          <form @submit.prevent="save">
            <div class="form-group">
              <Select
                v-model="form.plan"
                :errors="$page.props.errors.plan"
                label="Current plan"
                :items="plans"
                autofocus
              />
            </div>
            <div class="form-group">
              <Select
                v-model="form.schedule"
                :errors="$page.props.errors.schedule"
                label="Invoice schedule"
                :items="schedule"
              />

              <h3 class="mt-5">Email Notifications</h3>
              <div class="form-group">
                <Checkbox
                  disabled
                  v-model="form.email_notifications"
                  :errors="$page.props.errors.email_notifications"
                  label="Updates to Clausify"
                  val="updates"
                />
                <Checkbox
                  disabled
                  v-model="form.email_notifications"
                  :errors="$page.props.errors.email_notifications"
                  label="Updates to Laws and Regulations"
                  val="laws"
                />
                <Checkbox
                  v-model="form.email_notifications"
                  :errors="$page.props.errors.email_notifications"
                  label="An invoice is due (2 Days Notice)"
                  val="due"
                />
                <Checkbox
                  v-model="form.email_notifications"
                  :errors="$page.props.errors.email_notifications"
                  label="An invoice is overdue"
                  val="overdue"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-3">
                <div class="form-group">
                  <LoadingButton
                    :loading="saving"
                    class="btn btn-block btn-primary "
                    type="submit"
                  >
                    Save
                  </LoadingButton>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Organisation>
</template>

<script>
import Organisation from './Organisation.vue';
import Select from '@/Shared/Inputs/Select.vue';
import Checkbox from '@/Shared/Inputs/Checkbox.vue';
import LoadingButton from '@/Shared/LoadingButton.vue';

export default {
  components: {
    Organisation,
    Select,
    Checkbox,
    LoadingButton,
  },

  props: {
    organisation: Object,
  },

  data() {
    return {
      saving: false,
      form: this.$inertia.form({
        plan: this.organisation.plan,
        schedule: this.organisation.schedule,
        email_notifications: this.organisation.email_notifications,
      }),
      plans: [
        {
          value: '',
          label: 'Please choose a plan...',
        },
        {
          value: 'gold',
          label: 'Gold',
        },
        {
          value: 'silver',
          label: 'Silver',
        },
        {
          value: 'bronze',
          label: 'Bronze',
        },
      ],
      schedule: [
        {
          value: '',
          label: 'Please choose a schedule...',
        },
        {
          value: 'weekly',
          label: 'Weekly',
        },
        {
          value: 'monthly',
          label: 'Monthly',
        },
        {
          value: 'yearly',
          label: 'Yearly',
        },
      ],
    };
  },

  methods: {
    save() {
      this.saving = true;

      this.form.put(this.route('organisation.update', [this.organisation.id]), {
        preserveScroll: true,
        onSuccess: () => {
          this.saving = false;
        },
        onError: (error) => {
          this.saving = false;
          throw new Error(error);
        },
      });
    },
  },
};
</script>
